import { Component, Input, OnInit } from '@angular/core';
import { IFolderItem, IFolderList } from '../multipart.interface';
import { FileClass } from '../file.class';

@Component({
  selector: 'mango-item-upload',
  templateUrl: './aws-item-upload.component.html',
  styleUrls: ['./aws-item-upload.component.scss'],
})
export class AwsItemUploadComponent implements OnInit {
  @Input() data!: any;
  @Input() listView: string = 'grid';
  @Input() folder!: IFolderList;
  @Input() type: string = 'single';
  @Input() total: number = 0;

  progress: number = 0;
  classify: string = '';
  extension: string = '';
  preview: any;
  hasPreview: boolean = false;

  constructor() {}

  ngOnInit() {
    if (this.data) {
      this.processData();
    }
  }

  async processData() {
    const fileClass = new FileClass(this.data.file);
    this.classify = (await fileClass.classify()) as string;
    this.extension = this.getFileExtension(this.data.file.name);

    if (this.classify === 'image') {
      this.preview = this.resizeImageToSpecificWidth(this.data.file);
      this.hasPreview = true;
    }
  }

  getFileExtension(filename: any) {
    return filename
      .slice((Math.max(0, filename.lastIndexOf('.')) || Infinity) + 1)
      .toUpperCase();
  }

  resizeImageToSpecificWidth(file: any) {
    // const reader = new FileReader();
    //
    // reader.onload = (e) => {
    //   this.preview = e.target.result;
    // };
    //
    // reader.readAsDataURL(file);

    return window.URL.createObjectURL(file);
  }

  onSelectedHandle(event: any) {}
}
